/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface IntegrationDetailEntry {
  id: string;
  name: string;
  tagline: string;
  domain: string;
  category: string;
  version: string;
  version_date: string;
  website: string;
  documentation: string;
  contact: string;
  overview: string[];
  how_it_works: string[];
  configure: string[];
  screenshots: string[];
}
